import {TicketInSeriesVo} from '../../common/shared/api/nicolas/vo/TicketInSeriesVo.interface';
import {TicketItemInSeriesVo} from '../../common/shared/api/nicolas/vo/TicketItemInSeriesVo.interface';
import {TicketInSeries} from '../generated/types';
import {createTicketItemInSeries} from './TicketItemInSeries';

export function createTicketInSeries({
  series_title,
  is_end,
  refund_info,
}: TicketInSeriesVo): TicketInSeries {
  return {
    seriesTitle: series_title,
    isEnd: is_end,
    refundInfo: refund_info?.map((info: TicketItemInSeriesVo) =>
      createTicketItemInSeries(info)
    ),
  };
}
